import gql from 'graphql-tag';

export const ContentBodyConvertQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query ContentBodyConvertQuery(
			$from: String!
			$to: String!
			$body: String!
			$contentIdContext: String
		) @experimental {
			experimentalContentBodyConvert(
				body: $body
				from: $from
				to: $to
				contentIdContext: $contentIdContext
			) {
				value
			}
		}
	`;
